import { render, staticRenderFns } from "./BadgeCandidate.vue?vue&type=template&id=f8e4205a&scoped=true"
import script from "./BadgeCandidate.vue?vue&type=script&lang=js"
export * from "./BadgeCandidate.vue?vue&type=script&lang=js"
import style0 from "./BadgeCandidate.vue?vue&type=style&index=0&id=f8e4205a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e4205a",
  null
  
)

export default component.exports